import { createTheme } from '@mui/material/styles';
import { teal, grey } from '@mui/material/colors';
import './fonts.css';

// Define the light theme if we remove these it defaults to the MUI predefined colors
const lightTheme = createTheme({
  palette: {
    mode: 'light',
    //Setting primary color throughout the application
    primary: {
      main: '#03A3DB',
      light: '#0191C4',
      contrastText: '#FBFDFF', //Used for text color
    },
    //Setting secondary color throughout the application
    success: {
      main: '#21BB6E',
      light: '#21BB6E',
      contrastText: '#FBFDFF', //Used for text color
    },
    secondary: {
      main: '#848B90',
      light: '#848B90',
      contrastText: '#FBFDFF', //Used for text color
    },
    //Setting for the text color make sure it's in rgb only
    text: {
      primary: '#222222',
      secondary: '#848B90',
      disabled: '#61676C',
    },
    //Color setting fpr success, warning and error

    warning: {
      main: '#E1A500',
    },
    error: {
      main: '#EB4C60',
    },

    background: {
      default: '#F5F8FB',
      paper: '#FAFCFF',
    },
  },
  //Setting typography
  typography: {
    fontFamily: 'Inter-custom',
    htmlFontSize: 12,
    //Setting font sizes
    h1: {
      fontWeight: 700,
      fontSize: 28,
    },
    h2: {
      fontSize: 24,
      fontWeight: 700,
    },
    h3: {
      fontWeight: 700,
      fontSize: 20,
    },
    h4: {
      fontSize: 18,
      fontWeight: 700,
    },
    h5: {
      fontSize: 16,
      fontWeight: 600,
    },
    h6: {
      fontSize: 14,
      fontWeight: 600,
    },
    body1: {
      fontSize: 16,
    },
    body2: {
      fontSize: 14,
      fontWeight: 500,
    },
    body3: {
      fontSize: '12px',
      fontWeight: 500,
      lineHeight: 1.5,
      display: 'block',
    },
    subtitle1: {
      fontSize: '14px',
      fontWeight: 800,
    },
    subtitle2: {
      fontSize: '12px',
      fontWeight: 700,
    },
    caption: {
      fontSize: '10px',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '24px',
          padding: '8px 16px',
          fontSize: '12px',
          fontWeight: '700',
          lineHeight: '14.52px',
          // fontFamily: 'Custom-Inter',
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: ({ theme }) => ({
          fontSize: '16px',
          fontWeight: '600',
          color: '#FFFFFF',
          backgroundColor: `${theme.palette.primary.main} !important`,
          padding: '8px',
        }),
      },
    },
    MuiBadge: {
      styleOverrides: {
        badge: {
          width: '14px',
          fontSize: '10px',
          fontWeight: '500',
          height: '14px',
          minHeight: '14px',
          minWidth: '14px',
          top: '5%',
          right: '5%',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontSize: '10px',
          fontWeight: '500',
          borderRadius: '4px',
          paddingTop: '4px',
          paddingBottom: '4px',
          lineHeight: '130%',
          '& .MuiChip-label': {
            color: '#222222', // Replace #yourColor with your desired color
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          width: 28,
          height: 16,
          padding: 0,
          display: 'flex',
        },
        switchBase: {
          padding: 2,
          '&.Mui-checked': {
            transform: 'translateX(12px)',
            color: '#FBFDFF',
            '& + .MuiSwitch-track': {
              opacity: 1,
              backgroundColor: '#03A3DB',
            },
          },
          '&.Mui-checked + .MuiSwitch-track': {
            backgroundColor: '#03A3DB', // Dark mode alternative
          },
        },
        thumb: {
          width: 12,
          height: 12,
          borderRadius: 6,
          boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
          transition: 'width 200ms',
        },
        track: {
          borderRadius: 8,
          opacity: 1,
          backgroundColor: '#848B90',
          boxSizing: 'border-box',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          border: '1.6px solid #E6ECF1',
          borderRadius: '24px',
          height: '40px',
        },
        select: {
          borderRadius: '24px',
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          border: '1px solid #E6ECF1',
          borderRadius: '24px',
        },
        // inputRoot: {
        //   fontSize: '12px', // font size of input value
        // },
        tag: {
          fontSize: '12px', // font size of chips (for multiple select)
        },
        option: {
          fontSize: '12px', // font size of dropdown options
        },
      },
    },

    // MuiInputBase: {
    //   styleOverrides: {
    //     root: {

    //     '& .MuiOutlinedInput-root': {
    //         border: 'none !important',
    //         borderRadius: '24px !important',
    //         borderColor:'#FFFFFF !important'
    //       },
    //     },
    //   },
    // },

    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-input': {
            color: '#222222', // Input text color
            fontSize: '14px',
            fontWeight: 500,
            // letterSpacing: '0.5px',
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: '24px',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#E6ECF1',
          border: '1.6px solid #E6ECF1',
          borderRadius: '24px',
          fontSize: '16px',
          fontWeight: '600',
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none !important',
            borderRadius: '24px !important',
          },
          '&:hover': {
            border: '1.6px solid #03A3DB',
            backgroundColor: '#FBFDFF',
          },
          '&.Mui-focused': {
            border: '1.6px solid #03A3DB',
            backgroundColor: '#FBFDFF',
            borderRadius: '24px !important',
          },

          // Autofill fix
          '& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active':
            {
              WebkitBoxShadow: '0 0 0 1000px transparent inset',
              WebkitTextFillColor: '#000',
              transition: 'background-color 5000s ease-in-out 0s',
              borderRadius: '24px',
            },
        },
        notchedOutline: {
          border: 'none !important',
          '&.Mui-focused': {
            border: '1.6px solid #03A3DB !important',
            backgroundColor: '#FBFDFF',
          },
        },
        input: {
          '&::placeholder': {
            color: '#848B90',
            opacity: 1,
            fontSize: '12px',
            fontWeight: '500 !important',
          },
        },
        adornedStart: {
          '&.Mui-focused': {
            color: 'inherit',
          },
        },
      },
    },

    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: '16px',
          fontWeight: '600',
          color: '#222222',
          paddingRight: 0,
          paddingLeft: 0,
          minWidth: 'auto',
          marginRight: '24px',

          '&:last-of-type': {
            marginRight: 0, // Remove margin for the last tab
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '& .MuiSvgIcon-root': { fontSize: '18px' },
        },
      },
    },

    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: '12px',
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '24px',
          paddingTop: '6px',
          borderRadius: '12px',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          // borderRadius: '12px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          '&:last-child': {
            paddingBottom: '16px',
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          border: 'none',
          boxShadow: '0px 4px 20.5px rgba(0, 0, 0, 0.05)',
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          border: 'none',
          borderRadius: '8px',
          boxShadow: '10px 4px 20.5px 0px rgba(0, 0, 0, 0.05)',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: '14px',
          fontWeight: '500',
          '&:hover': {
            backgroundColor: 'transparent', // Change hover color
          },
          '&.Mui-selected': {
            backgroundColor: 'transparent !important', // No background when selected
          },
          '&.Mui-focusVisible': {
            backgroundColor: 'transparent !important', // No background when focused
          },
          '&.active': {
            backgroundColor: 'transparent !important', // No background when focused
          },
        },
      },
    },

    MuiDivider: {
      styleOverrides: {
        root: {
          borderRadius: '1px',
          color: '#E6ECF1',
        },
      },
    },
    MuiTooltip: {
      defaultProps: {
        slotProps: {
          popper: {
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, -10], // Adjusts the tooltip position globally
                },
              },
            ],
          },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: '#03A3DB',
          fontSize: '12px',
          fontWeight: '600 !important',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '16px 24px', // Reducing padding for smaller row height
          fontSize: '14px', // Adjust the font size
          lineHeight: 1.5, // Adjust the line height
          textAlign: 'left',
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#E6ECF1',
          borderRadius: '4px',
          '& th': {
            fontSize: '12px',
            fontWeight: '500',
            color: '#848B90',
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          padding: '4px 8px',
          height: '15px',
          minHeight: '15px',
          '& td': {
            fontSize: '14px',
            fontWeight: '500',
            color: '#222222',
          },
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          borderRadius: '5px',
          background: '#fff',
          backgroundColor: 'transparent',
          backgroundImage: 'none',
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          border: `0.5px solid #E7F0F0`, // Using primary color
          borderRadius: '8px',
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: '#11466C',
            color: '#FBFDFF',
          },
          '&.Mui-selected:hover': {
            backgroundColor: '#11466C',
            color: '#FBFDFF',
            border: '1px solid #11466C',
          },
          '&:hover': {
            backgroundColor: '#11466C',
            color: '#FBFDFF',
            border: '1px solid #11466C',
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          '& .MuiSwitch-root + .MuiFormControlLabel-label': {
            fontSize: '14px',
            fontWeight: '500',
            color: '#848B90',
            lineHeight: '16.94px',
          },
          '& .MuiCheckbox-root + .MuiFormControlLabel-label': {
            fontSize: '14px',
            fontWeight: '500',
            color: '#222222',
          },
          '& .MuiRadio-root + .MuiFormControlLabel-label': {
            fontSize: '12px',
            fontWeight: '500',
            color: '#222222',
          },
        },
        label: {
          whiteSpace: 'normal',
          wordBreak: 'break-word',
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          fontSize: '12px',
          border: 'none',
          padding: '0px 8px',
          color: '#222222',
          backgroundColor: 'transparent !important', // Prevent default background
          '&:hover': {
            backgroundColor: 'transparent !important', // Remove hover effect
          },
          '&.Mui-selected': {
            color: '#03A3DB',
            backgroundColor: 'transparent !important', // Remove selected background
            boxShadow: 'none', // Ensure no box-shadow effects
          },
          '&.Mui-selected:hover': {
            backgroundColor: 'transparent !important',
            color: '#03A3DB',
          },
        },
      },
    },
  },
});

// Define the dark theme if we remove these it defaults to the MUI predefined colors
const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    //Setting primary color throughout the application
    primary: {
      main: teal[500],
      contrastText: '#FFFFFF', //Used for text color
    },
    //Setting secondary color throughout the application
    secondary: {
      main: grey[500],
      contrastText: '#FFFFFF', //Used for text color
    },
    //Setting for the text color make sure it's in rgb only
    text: {
      primary: 'rgb( 255 , 255 , 255)',
      secondary: 'rgb( 255 , 255 , 255)',
    },
    //Color setting fpr success, warning and error
    success: {
      main: '#37d183',
    },
    warning: {
      main: '#f9b803',
    },
    error: {
      main: '#eb4c60',
    },
  },
  //Setting typography
  typography: {
    fontFamily: 'Custom-Inter',
    htmlFontSize: 12,
    h1: {
      // fontFamily: 'Custom-Inter',
      fontWeight: 700,
      fontSize: 30,
    },
    h2: {
      fontSize: 24,
      fontWeight: 700,
    },
    h3: {
      fontWeight: 700,
      fontSize: 20,
    },
    h4: {
      fontSize: 18,
      fontWeight: 700,
    },
    h5: {
      fontSize: 16,
      fontWeight: 700,
    },
    h6: {
      fontSize: 14,
      fontWeight: 700,
    },
    body1: {
      fontSize: 14,
    },
    body2: {
      fontSize: 14,
    },
    subtitle1: {
      fontSize: 14,
    },
    subtitle2: {
      fontSize: 12,
    },
    caption: {
      fontSize: '10px',
    },
  },
  components: {
    MuiAvatar: {
      styleOverrides: {
        root: {
          fontSize: '18px', // Override text size inside the avatar globally
          // fontFamily: 'Roboto, sans-serif', // Specify a custom font family for the avatar
        },
      },
    },
    MuiBadge: {
      styleOverrides: {
        badge: {
          fontSize: '12px',
          width: '14px',
          height: '14px',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '& svg path': {
            stroke: '#ffff',
          },
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          '& svg path': {
            stroke: '#ffff',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          '& svg path': {
            stroke: '#ffff',
          },
        },
      },
    },

    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          '& svg path': {
            stroke: '#ffff',
          },
        },
      },
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          '& svg path': {
            stroke: '#ffff',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '16px 24px', // Reducing padding for smaller row height
          fontSize: '14px', // Adjust the font size
          lineHeight: 1.5, // Adjust the line height
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          padding: '4px 8px',
          height: '20px', // Adjust row height
          minHeight: '20px',
          '&:last-child td': { border: 0 },
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          borderRadius: '5px',
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          border: `0.5px solid #E7F0F0`, // Using primary color
          borderRadius: '8px',
        },
      },
    },
  },
});

// Export both theme
export { lightTheme, darkTheme };
